module.exports = __webpack_public_path__ + "static/media/wyxw.5ef231a4.svg";